<template>
  <section class="mx-auto">
    <RouterView />

    <Notifications />

    <Modal
      :model-value="shouldShowCompactModePrompt"
      size="small"
      :show-close-button="false"
      :close-on-backdrop="false"
    >
      <div class="flex flex-col gap-4 text-center items-center py-2">
        <h2 class="m-0 text-2xl font-bold text-darkPurple">
          {{ t("components.sideMenu.compactModePromptTitle") }}
        </h2>

        <p class="m-0 text-sm leading-6 text-[#6B6B8A]">
          {{ t("components.sideMenu.compactModePromptDescription") }}
        </p>

        <div class="flex flex-col-reverse sm:flex-row gap-3 w-full mt-2">
          <button
            type="button"
            class="flex-1 py-2.5 rounded-2xl border border-gray-300 text-darkPurple hover:bg-gray-50 transition-all"
            @click="disableCompactMode"
          >
            {{ t("components.sideMenu.compactModeDecline") }}
          </button>

          <button
            type="button"
            class="flex-1 py-2.5 rounded-2xl bg-purple-gradient text-white transition-all"
            @click="enableCompactMode"
          >
            {{ t("components.sideMenu.compactModeAccept") }}
          </button>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import Modal from "./components/Modal.vue";
import Notifications from "./components/Notifications.vue";
import {
  disableCompactMode,
  enableCompactMode,
  shouldShowCompactModePrompt,
} from "./methods/utils/initCompactMode";

const { t } = useI18n();
</script>
